import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import Tooltip from '@mui/material/Tooltip';

const FOLLOW_SELECTION_HINT =
	'When on, selecting package data focuses the datasheet viewer on the datasheet evidence it came from.';

const SHOW_REJECTED_HINT = 'Datasheet regions rejected as valid evidence are hidden by default. Turn on to show them.';

/** Props for {@link EvidencePanelToolbar}. */
export interface EvidencePanelToolbarProps {
	/** Whether the panel shows the rejected locators it hides by default. */
	showRejected: boolean;
	/** Called with the viewer's choice when they flip the switch that shows rejected locators. */
	onShowRejectedChange: (showRejected: boolean) => void;
	/** Whether datasheet windows follow the viewer's row pick; the follow switch is left out when omitted. */
	followSelection?: boolean;
	/** Called with the viewer's choice when they flip the follow switch; the switch is left out when omitted. */
	onFollowSelectionChange?: (followSelection: boolean) => void;
}

/**
 * The evidence panel's controls, held at the top of the panel while its evidence scrolls beneath them: a switch that
 * has datasheet windows follow the viewer's row pick, when asked for, and a switch that reveals the rejected locators
 * every list in the panel hides by default. Hovering either switch says what it does.
 */
export function EvidencePanelToolbar({
	showRejected,
	onShowRejectedChange,
	followSelection,
	onFollowSelectionChange,
}: EvidencePanelToolbarProps) {
	return (
		<div
			role='toolbar'
			aria-label='Evidence options'
			className='sticky top-0 z-10 flex shrink-0 flex-wrap justify-end gap-x-4 border-b border-gray-a4 bg-background px-3 py-1'
		>
			{followSelection !== undefined && onFollowSelectionChange !== undefined && (
				<Tooltip title={FOLLOW_SELECTION_HINT} describeChild>
					<FormControlLabel
						className='mr-0'
						control={
							<Switch
								size='small'
								checked={followSelection}
								onChange={(_event, checked) => onFollowSelectionChange(checked)}
							/>
						}
						label='Follow selection'
					/>
				</Tooltip>
			)}
			<Tooltip title={SHOW_REJECTED_HINT} describeChild>
				<FormControlLabel
					className='mr-0'
					control={
						<Switch size='small' checked={showRejected} onChange={(_event, checked) => onShowRejectedChange(checked)} />
					}
					label='Show rejected'
				/>
			</Tooltip>
		</div>
	);
}
